import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueKeyCloak from '@dsb-norge/vue-keycloak-js'
import vuetify from './plugins/vuetify'
import CustomComponents from './plugins/custom-components'
import VeeValidate from 'vee-validate'
import VeeValidatePtBR from 'vee-validate/dist/locale/pt_BR'

Vue.use(CustomComponents)
Vue.use(VeeValidate, {
  locale: 'pt_BR',
  dictionary: {
    pt_BR: VeeValidatePtBR
  }
})
Vue.use(VueKeyCloak, {
  config: {
    authUrl: process.env.VUE_APP_AUTH_URL, 
    authRealm: process.env.VUE_APP_AUTH_REALM, 
    authClientId: process.env.VUE_APP_AUTH_CLIENT_ID
  },
  onReady: (keycloak) => {
    Vue.config.productionTip = false

    new Vue({
      router,
      store,
      vuetify,
      render: h => h(App)
    }).$mount('#app')
  }
})
